import axios from 'axios';
import { message } from 'antd';
import localStorage from '../../../../utils/localStorage';
import {
  GETUSERLIST,
  // API_RUBUSMASTERS,
  DATA_ALERT_RULES
} from '../../../../commons/api';

export async function recipientListAPI() {
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    let Authorization = 'Bearer ' + token;
    const recipientListApi = {
      method: 'GET',
      url: `${GETUSERLIST.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: Authorization
      }
    };
    return axios(recipientListApi)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.info(err.response.data.message);
        }
      });
  }
  export async function deviceListApi() {
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    let Authorization = 'Bearer ' + token;
    const recipientListApi = {
      method: 'GET',
      url: `${DATA_ALERT_RULES.GetAllDeviceTypes}?SiteId=${siteId}`,
      headers: {
        Authorization: Authorization
      }
    };
    return axios(recipientListApi)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.info(err.response.data.message);
        }
      });
  }
  export async function updateRuleStatus(payload) {
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
  
    let Authorization = 'Bearer ' + token;
    const upateRuleStatus = {
      method: 'PATCH',
      url: `${DATA_ALERT_RULES.UpdateAlertRuleStatus}?SiteId=${siteId}&Id=${payload.Id}&RuleStatus=${payload.RuleStatus}`,
      headers: {
        Authorization: Authorization
      }
    };
    return axios(upateRuleStatus)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.info(err.response.data.message);
        }
      });
  }